import {
  MASTER_SYSTEM_SERVER_LIST,
  MASTER_SYSTEM_SERVER_LIST_SUCCESS,
  MASTER_SYSTEM_SERVER_LIST_FAILURE,
  MASTER_SYSTEM_SERVER_DEPLOY,
  MASTER_SYSTEM_SERVER_DEPLOY_SUCCESS,
  MASTER_SYSTEM_SERVER_DEPLOY_FAILURE,
} from "./actionType";

const initialState = {
  // LIST
  masterSystemServerList: [],
  masterSystemServerListLoading: false,
  masterSystemServerListError: null,

  // DEPLOY
  masterSystemServerDeploy: {},
  masterSystemServerDeployLoading: false,
  masterSystemServerDeployError: null,
};

const masterSystemServerReducer = (state = initialState, action) => {
  switch (action.type) {
    // LIST
    case MASTER_SYSTEM_SERVER_LIST:
      return {
        ...state,
        masterSystemServerListLoading: true,
        masterSystemServerListError: null,
      };

    case MASTER_SYSTEM_SERVER_LIST_SUCCESS:
      return {
        ...state,
        masterSystemServerList: action.payload,
        masterSystemServerListLoading: false,
      };

    case MASTER_SYSTEM_SERVER_LIST_FAILURE:
      return {
        ...state,
        masterSystemServerListLoading: false,
        masterSystemServerListError: action.payload,
      };

    // DEPLOY
    case MASTER_SYSTEM_SERVER_DEPLOY:
      return {
        ...state,
        masterSystemServerDeployLoading: true,
        masterSystemServerDeployError: null,
      };

    case MASTER_SYSTEM_SERVER_DEPLOY_SUCCESS:
      return {
        ...state,
        masterSystemServerDeploy: action.payload,
        masterSystemServerDeployLoading: false,
      };

    case MASTER_SYSTEM_SERVER_DEPLOY_FAILURE:
      return {
        ...state,
        masterSystemServerDeployLoading: false,
        masterSystemServerDeployError: action.payload,
      };

    default:
      return state;
  }
};

export default masterSystemServerReducer;
